import React, { useState } from 'react';
import SettingsIcon from '@material-ui/icons/Settings';
import './Settings.css';
import { IconButton } from '@material-ui/core';
import Modal from './Modal';

function Settings() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      {/* <IconButton>
        <SettingsIcon onClick={() => setIsOpen(true)} fontSize="large" />
      </IconButton> */}

      <Modal open={isOpen}>Modal Content</Modal>

      <div style={{ fontSize: '12px', fontFamily: 'Karla', fontSize: '1rem' }}>
        The INFINITE Pomodoro Timer. Like no other.
      </div>
    </div>
  );
}

export default Settings;
